// extracted by mini-css-extract-plugin
export default {"root":"Loader_root__myEhF","loader":"Loader_loader__+lRPl","rotation":"Loader_rotation__7eXxl","root_kids":"Loader_root_kids__smCpK"};